    $(document).ready(function(){
  	$('.tabs_cont ul.tabs li').click(function(){
  		var tab_id = $(this).attr('data-tab');

  		$('.tabs_cont ul.tabs li').removeClass('current');
  		$('.tabs_cont .tab-content').removeClass('current');

  		$(this).addClass('current');
  		$("#"+tab_id).addClass('current');
  	})
  })


$(document).ready(function() {
   var $sections = $('.custom-cards, .custom-faq-home');

   var callback = function(entries, observer) {
       entries.forEach(function(entry) {
           if (entry.isIntersecting) {
               $(entry.target).addClass('in-view');
           } else{
               $(entry.target).removeClass('in-view');
           }
       });
   };

   var observer = new IntersectionObserver(callback, {
       root: null, 
       threshold: 0.1 
   });

   $sections.each(function() {
       observer.observe(this);
   });
});


// $(".head-product-faq-section").click(function(){
// $(this).siblings(".description-ptc").slideToggle();
// });

